import React from "react";

import { useTranslation } from "react-i18next";

import * as Field from "./styles";

interface ViewFieldProps {
  label: string;
  value?: string;
}
export function ViewField({ label, value }: ViewFieldProps) {
  const { t: translate } = useTranslation();

  return (
    <Field.Wrapper>
      <Field.Label>{label}</Field.Label>
      <Field.Text isEmpty={!value}>{value || translate("empty")}</Field.Text>
    </Field.Wrapper>
  );
}
